import React from 'react';
import { MapPin, Zap, Square } from 'lucide-react';

const WindPotentialStatisticsRow = ({ onshoreWindData, offshoreWindData }) => {
  if (!(onshoreWindData || offshoreWindData)) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-wrap gap-2">
        <div className="bg-gray-50 rounded p-2 flex-shrink-0">
          <div className="flex items-center">
            <MapPin className="h-4 w-4 text-gray-600 mr-2 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-xs text-gray-600 whitespace-nowrap">Zones</p>
              <p className="text-sm font-bold">
                {(() => {
                  const onshoreZones = onshoreWindData?.statistics?.total_cells || 0;
                  const offshoreZones = offshoreWindData?.statistics?.total_cells || 0;
                  const totalZones = onshoreZones + offshoreZones;

                  if (onshoreZones > 0 && offshoreZones > 0) {
                    return (
                      <span>
                        <span className="text-green-600">{onshoreZones.toLocaleString()}</span> +{' '}
                        <span className="text-blue-600"> {offshoreZones.toLocaleString()}</span> ={' '}
                        {totalZones.toLocaleString()}
                      </span>
                    );
                  } else if (onshoreZones > 0) {
                    return <span className="text-green-600">{onshoreZones.toLocaleString()}</span>;
                  } else if (offshoreZones > 0) {
                    return <span className="text-blue-600">{offshoreZones.toLocaleString()}</span>;
                  } else {
                    return '0';
                  }
                })()}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 rounded p-2 flex-shrink-0">
          <div className="flex items-center">
            <Zap className="h-4 w-4 text-gray-600 mr-2 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-xs text-gray-600 whitespace-nowrap">Capacity</p>
              <p className="text-sm font-bold">
                {(() => {
                  const onshoreCapacity = onshoreWindData?.statistics?.total_capacity_mw || 0;
                  const offshoreCapacity = offshoreWindData?.statistics?.total_capacity_mw || 0;
                  const totalCapacity = onshoreCapacity + offshoreCapacity;
                  const onshoreCapacityGW = onshoreCapacity / 1000;
                  const offshoreCapacityGW = offshoreCapacity / 1000;
                  const totalCapacityGW = totalCapacity / 1000;

                  if (onshoreCapacity > 0 && offshoreCapacity > 0) {
                    const onshoreLabel = onshoreCapacityGW.toLocaleString(undefined, { maximumFractionDigits: 1 });
                    const offshoreLabel = offshoreCapacityGW.toLocaleString(undefined, { maximumFractionDigits: 1 });
                    const totalLabel = totalCapacityGW.toLocaleString(undefined, { maximumFractionDigits: 1 });
                    return (
                      <span>
                        <span className="text-green-600">{onshoreLabel}</span> +{' '}
                        <span className="text-blue-600"> {offshoreLabel}</span> ={' '}
                        {totalLabel} GW
                      </span>
                    );
                  } else if (onshoreCapacity > 0) {
                    return (
                      <span className="text-green-600">
                        {onshoreCapacityGW.toLocaleString(undefined, { maximumFractionDigits: 1 })} GW
                      </span>
                    );
                  } else if (offshoreCapacity > 0) {
                    return (
                      <span className="text-blue-600">
                        {offshoreCapacityGW.toLocaleString(undefined, { maximumFractionDigits: 1 })} GW
                      </span>
                    );
                  } else {
                    return '0 GW';
                  }
                })()}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 rounded p-2 flex-shrink-0">
          <div className="flex items-center">
            <Square className="h-4 w-4 text-gray-600 mr-2 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-xs text-gray-600 whitespace-nowrap">Suitable Area</p>
              <p className="text-sm font-bold">
                {(
                  (onshoreWindData?.statistics?.total_suitable_area_km2 || 0) +
                  (offshoreWindData?.statistics?.total_suitable_area_km2 || 0)
                ).toLocaleString()}{' '}
                km²
              </p>
            </div>
          </div>
        </div>
    </div>
  );
};

export default WindPotentialStatisticsRow;
